var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Filter__Icn/40px/Filter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Filter__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Filter__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12,9 L11.8496256,9.00527274 C10.2682491,9.11699491 9.42235457,10.9796505 10.438332,12.2494772 L17,20.451 L17,26 C17,26.530433 17.2107137,27.0391408 17.5857864,27.4142136 L19.5857864,29.4142136 L19.6992001,29.5198305 C20.9705752,30.6208836 23,29.7294035 23,28 L23,20.449 L29.561668,12.2494772 C30.6093947,10.9399684 29.6770643,9 28,9 L12,9 Z M12,11 L28,11 L21,19.749 L21,28 L19,26 L19,19.749 L12,11 Z",
    id: ".._.._src_svg_Icn_40px_Filter__Combined-Shape-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.40a7c9c22ed095a84242c9e83d381676.svg";
export { ForwardRef as ReactComponent };